import moment from 'moment';

export const UNKNOWN_DAY_KEY = 'unknown';
export const UNKNOWN_DAY_LABEL = 'Date unavailable';

const datesAreSameDay = (date1: Date, date2: Date) => moment(date1).isSame(date2, 'day');

const needsDayLabelGenerated = (lastDate: Date | null, nextDate: Date | null) => {
  if (!lastDate) return true;
  if (!nextDate) return false;

  return !datesAreSameDay(lastDate, nextDate);
};

const dayKey = (date: Date | null): string =>
  date ? moment(date).format('YYYY-MM-DD') : UNKNOWN_DAY_KEY;

const generateDayLabel = (date: Date | null) => {
  if (!date) {
    return UNKNOWN_DAY_LABEL;
  }

  const day = moment(date);
  if (day.isSame(moment(), 'day')) {
    return 'Today';
  }

  if (day.isSame(moment().subtract(1, 'day'), 'day')) {
    return 'Yesterday';
  }

  if (moment().diff(day, 'days') < 7) {
    return day.format('dddd');
  }

  return day.format('MMM Do YYYY');
};

export { needsDayLabelGenerated, generateDayLabel, datesAreSameDay, dayKey };
